var map = {
	"./de/author_blog.json": "./src/localization/Collections/translated_files_blogs/de/author_blog.json",
	"./de/blog_topic.json": "./src/localization/Collections/translated_files_blogs/de/blog_topic.json",
	"./es/author_blog.json": "./src/localization/Collections/translated_files_blogs/es/author_blog.json",
	"./es/blog_topic.json": "./src/localization/Collections/translated_files_blogs/es/blog_topic.json",
	"./fr/author_blog.json": "./src/localization/Collections/translated_files_blogs/fr/author_blog.json",
	"./fr/blog_topic.json": "./src/localization/Collections/translated_files_blogs/fr/blog_topic.json",
	"./ja/author_blog.json": "./src/localization/Collections/translated_files_blogs/ja/author_blog.json",
	"./ja/blog_topic.json": "./src/localization/Collections/translated_files_blogs/ja/blog_topic.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/localization/Collections/translated_files_blogs sync recursive .json$";